import {
  RegisterButtonWrapper,
  RegisterHeadingWrapper,
  IconWrapper,
  SubscribeButtonWrapper,
} from './styled';
import {
  Heading,
  Text,
  Button,
  DiscoverOutline,
  ChevronRightSmallSolid,
  useTheme,
} from '@simplywallst/ui-core';
import { useTracking } from 'react-tracking';
import { useState } from 'react';
import GuestRegistrationModal from '@components/GuestRegistrationModal';

const RegisterButton = () => {
  const { trackEvent } = useTracking();
  const [open, setOpen] = useState(false);
  const theme = useTheme();

  return (
    <RegisterButtonWrapper>
      <RegisterHeadingWrapper>
        <IconWrapper>
          <DiscoverOutline fill={theme.color.chart01} />
        </IconWrapper>

        <Heading as="h3" typography="baseStrong" color="black">
          Subscribe to the Market Insights
        </Heading>
      </RegisterHeadingWrapper>
      <Text typography="base" color="black">
        Be the first to know when there's new Market Insights, delivered to your
        inbox weekly!
      </Text>

      <SubscribeButtonWrapper>
        <Button
          data-cy-id="register-market-insights"
          styleType="gentleLargeReverse"
          marginTop
          onClick={() => {
            setOpen(true);
            trackEvent({
              type: 'track',
              action: 'click',
              modifier: 'registerMarketInsights',
              subject: 'guestRegistrationModal',
            });
          }}
        >
          Register
          <ChevronRightSmallSolid />
        </Button>
      </SubscribeButtonWrapper>

      {open && (
        <GuestRegistrationModal
          canClose={true}
          onClose={() => {
            trackEvent({
              action: 'click',
              modifier: 'log_in_sign_up',
            });
            setOpen(false);
          }}
          onRegisterSuccess={() => {
            trackEvent({
              type: 'track',
              subject: 'desktopTopBarLoggedOut',
              modifier: 'registration',
              action: 'success',
            });
            setOpen(false);
          }}
        />
      )}
    </RegisterButtonWrapper>
  );
};

export default RegisterButton;
